"use client"

import { useContext } from "react"
import { SubContentContext } from "../SidebarContext"

export function useSubContent() {
  const context = useContext(SubContentContext)

  if (!context) {
    throw new Error("useSubContent must be used within a <Sidebar> component")
  }

  return context
}
